var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C17.1855 8 18.375 9.18945 18.375 10.625V18.5C18.375 19.9355 17.1855 21.125 15.75 21.125H2.625C1.14844 21.125 0 19.9355 0 18.5V10.625C0 9.18945 1.14844 8 2.625 8H3.9375V5.375C3.9375 2.50391 6.27539 0.125 9.1875 0.125C12.0586 0.125 14.4375 2.46289 14.4375 5.375V8H15.75ZM5.90625 5.375V8H12.4688V5.375C12.4688 3.57031 10.9922 2.09375 9.1875 2.09375C7.3418 2.09375 5.90625 3.57031 5.90625 5.375ZM16.4062 18.5V10.625C16.4062 10.2969 16.0781 9.96875 15.75 9.96875H2.625C2.25586 9.96875 1.96875 10.2969 1.96875 10.625V18.5C1.96875 18.8691 2.25586 19.1562 2.625 19.1562H15.75C16.0781 19.1562 16.4062 18.8691 16.4062 18.5Z",
    fill: "#584500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f53a3f79.svg";
export { ForwardRef as ReactComponent };